import React from 'react';
import { OdinController } from '@myosh/odin-components';
import type { Control } from 'react-hook-form';
import PasswordField from './password-field.component';
import type { PasswordFieldProps } from './password-field.component';

interface HfPasswordFieldProps extends PasswordFieldProps {
  control: Control;
}

export default function HfPasswordField({
  control,
  name = '',
  label,
  value,
  readOnly,
  required,
  validations,
  onChange,
  onChangeEvent,
  fieldValueConverter,
  onFocus,
}: HfPasswordFieldProps) {
  return (
    <OdinController
      name={name}
      defaultValue={value}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <PasswordField
          name={name}
          label={label}
          value={value}
          error={error?.message}
          readOnly={readOnly}
          required={required}
          validations={validations}
          onChange={onChange}
          onChangeEvent={onChangeEvent}
          onFocus={onFocus}
        />
      )}
    />
  );
}
